import React from 'react';
import Account from '../../pages/Account';

export default function AccountViewContainer({ user, emailVerified, auditLogs, onUpdateProfile, onChangePassword, onResendVerification }) {
  return (
    <Account
      user={user}
      emailVerified={emailVerified}
      auditLogs={auditLogs}
      onUpdateProfile={onUpdateProfile}
      onChangePassword={onChangePassword}
      onResendVerification={onResendVerification}
    />
  );
}
